import React, { useContext, useEffect, useState } from 'react'
import { EnvoieContext } from '../../context/envoieContext/EnvoieContext';
import { clientsOrEntreprises, communes, currentStatusEnvois, statusEnvois, typeDeliveries, typeEnvois, typeRamassages, wilayas } from '../../data';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import { AgenceContext } from '../../context/agenceContext/AgenceContext';
import { getEnvois } from '../../context/envoieContext/apiCalls';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls';
import { AuthContext } from '../../context/authContext/AuthContext';
import FilterIdInput from '../../components/filterIdInput/FilterIdInput';
import FilterDateInput from '../../components/filterDateInput/FilterDateInput';
import { CURRENT_URL } from "../../config/runtimeConfig";

/*** PDF Import ***/
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Bordereau from '../../components/bordereau/Bordereau';
import { restartEnvoie } from '../../context/envoieContext/EnvoieActions';
import FilterInput from '../../components/filterInput/FilterInput';

function Envoie() {
    const { dispatch, envois, isFetching, error, count: pages } = useContext(EnvoieContext);
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { user } = useContext(AuthContext);

    const { page = 1 } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);

    const [clientOrEntreprise, setClientOrEntreprise] = useState(() => {
        if (user.entreprise) {
            return clientsOrEntreprises[0];
        } else {
            return { nom: "Client", id: 2 };
        }
    })
    const [id, setId] = useState("");
    const [typeEnvoie, setTypeEnvoie] = useState({ nom: "Choisir Type d'Envoie", id: 0, });
    const [typeRamassage, setTypeRamassage] = useState({ nom: "Choisir Type Dépot", id: 0, });
    const [typeDelivery, setTypeDelivery] = useState({ nom: "Choisir Type Livraison", id: 0, });
    const [statusEnvoie, setStatusEnvoie] = useState({ nom: "Choisir le Statut", id: 0, });
    const [agenceCurrent, setAgenceCurrent] = useState({ nom: "Choisir Agence Actuelle", id: 0, });
    const [wilayaDepart, setWilayaDepart] = useState(wilayas[0]);
    const [currentStatusEnvoie, setCurrentStatusEnvoie] = useState({ nom: "Choisir Etat d'Envoie", id: 0, });
    const [dateEnvoie, setDateEnvoie] = useState("");
    const [nameArrived, setNameArrived] = useState("");
    const [telArrived, setTelArrived] = useState("");
    const [numberArrived, setNumberArrived] = useState("");

    const [groupEnvois, setGroupEnvois] = useState([]);
    const [bordActive, setBordActive] = useState(false);


    useEffect(() => {
        getEnvois(dispatch, pageSize, page, id, clientOrEntreprise.id, typeEnvoie.id, typeRamassage.id, typeDelivery.id, statusEnvoie.id, agenceCurrent.id, wilayaDepart.id, currentStatusEnvoie.id, nameArrived, telArrived, numberArrived, dateEnvoie);
    }, [dispatch, pageSize, page, id, clientOrEntreprise, typeEnvoie, typeRamassage, typeDelivery, statusEnvoie, agenceCurrent, wilayaDepart, currentStatusEnvoie, nameArrived, telArrived, numberArrived, dateEnvoie])

    useEffect(() => {
        navigate(`/envois/1`);
    }, [id, clientOrEntreprise, typeEnvoie, typeRamassage, typeDelivery, statusEnvoie, agenceCurrent, wilayaDepart, currentStatusEnvoie, nameArrived, telArrived, numberArrived, dateEnvoie])

    useEffect(() => {
        getAgencesByWilaya(dispatchAgence)
        dispatch(restartEnvoie());
    }, [])

    function checkSize(value) {
        if (value.length > 18)
            return value.substring(0, 16) + '...';
        else
            return value;
    }



    function groupEnvoisAddHandle(envois) {
        envois.map(envoie => {
            if (existElementInGroup(groupEnvois, envoie)) {
                setGroupEnvois(prev => prev.filter(item => item.id !== envoie.id))
            } else {
                setGroupEnvois(prev => [...prev, envoie])
            }
        })
    }
    function existElementInGroup(list, element) {
        return list.some(item => item.id === element.id)
    }

    function toutCocher(envois) {
        envois.map(envoie => {
            if (!existElementInGroup(groupEnvois, envoie)) {
                setGroupEnvois(prev => [...prev, envoie])
            }
        })
    }
    function toutDecocher() {
        setGroupEnvois([]);
    }


    const getBordereauHandler = async () => {
        if (groupEnvois.length === 0) {
            return
        }
        setBordActive(true);
        const pdf = new jsPDF({
            orientation: "portrait",
            unit: 'px',
            format: "a4"
        });
        const slipBords = document.querySelectorAll(`.slip-bord`);
        for (let i = 0; i < slipBords.length; i++) {
            const canvas = await html2canvas(slipBords[i], { scale: 3 });
            const bordData = canvas.toDataURL('image/png');

            const imgProperties = pdf.getImageProperties(bordData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

            if (i !== 0) {
                pdf.addPage();
            }
            pdf.addImage(bordData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        }
        if (groupEnvois.length === 1) {
            pdf.save(`NWE-${groupEnvois[0].id}.pdf`);
        } else {
            pdf.save('NWE-Bordereau.pdf');
        }
        setBordActive(false);
    }
    const getStatusClass = (statusCode) => {
        if (statusCode === 10) {
            return "preparation"
        } else if (statusCode === 1) {
            return "ramassage"
        } else if (statusCode === 8) {
            return "reception-agence"
        } else if (statusCode === 2) {
            return "depot-agence"
        } else if (statusCode === 3) {
            return "acheminement-depart"
        } else if (statusCode === 4) {
            return "acheminement-arrive"
        } else if (statusCode === 5) {
            return "livraison-domicile"
        } else if (statusCode === 6) {
            return "livraison-agence"
        } else if (statusCode === 9) {
            return "stock-agence"
        } else if (statusCode === 11) {
            return "retour-client"
        } else if (statusCode === 12) {
            return "livre"
        } else {
            return "stock-agence"
        }
    }
    const getTypeClass = (typeCode) => {
        if (typeCode === 1) {
            return "nwe"
        } else if (typeCode === 2) {
            return "livre"
        } else if (typeCode === 3) {
            return "retour"
        } else {
            return "annule"
        }
    }
    const getTypeDelivery = (type) => {
        if (type === 1) {
            return "a-domicile"
        } else if (type === 2) {
            return "en-agence"
        }
    }
    const getTypeEnvoie = (type) => {
        if (type === 1) {
            return "a-accuse"
        } else if (type === 2) {
            return "s-accuse"
        } else if (type === 3) {
            return "pick-up"
        }
    }


    return (
        <div className='container-global'>
            <AdminSideBar activeTab="envoie" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Envois :</span>
                </div>

                <div className='box-success' style={{ "maxWidth": "none", "margin": "0 0 20px" }}>Pour toutes informations, contactez-nous au {user.telephone}</div>

                {
                    error ? <ErrorComponent error={error} /> : (
                        <>
                            <div className="filter">
                                <span className="adv-research">Recherche Avancée</span>
                                <div className="filter-content">
                                    <FilterIdInput placeholder={'Tracking'} setItem={setId} />
                                    {user.entreprise && <DropDownComponent data={clientsOrEntreprises} itemChoisir={clientOrEntreprise} setItemChoisir={setClientOrEntreprise} filter />}

                                    <DropDownComponent data={[{ nom: "Choisir Type d'Envoie", id: 0, }, ...typeEnvois]} itemChoisir={typeEnvoie} setItemChoisir={setTypeEnvoie} filter />
                                    <DropDownComponent data={[{ nom: "Choisir Type Dépot", id: 0, }, ...typeRamassages]} itemChoisir={typeRamassage} setItemChoisir={setTypeRamassage} filter />
                                    <DropDownComponent data={[{ nom: "Choisir Type Livraison", id: 0, }, ...typeDeliveries]} itemChoisir={typeDelivery} setItemChoisir={setTypeDelivery} filter />
                                    <DropDownComponent data={[{ nom: "Choisir le Statut", id: 0, }, ...(statusEnvois.filter(item => item.id !== 7))]} itemChoisir={statusEnvoie} setItemChoisir={setStatusEnvoie} filter />
                                    <DropDownComponent data={[{ nom: "Choisir Agence Actuelle", id: 0, }, ...agencesByWilaya]} itemChoisir={agenceCurrent} setItemChoisir={setAgenceCurrent} filter />
                                    <DropDownComponent data={wilayas} itemChoisir={wilayaDepart} setItemChoisir={setWilayaDepart} filter />
                                    <DropDownComponent data={[{ nom: "Choisir Etat d'Envoie", id: 0, }, ...currentStatusEnvois]} itemChoisir={currentStatusEnvoie} setItemChoisir={setCurrentStatusEnvoie} filter />

                                    <FilterInput placeholder={"Nom Arrivé"} setItem={setNameArrived} />
                                    <FilterInput placeholder={"Tel Arrivé"} setItem={setTelArrived} />
                                    <FilterInput placeholder={"Nemero Arrivé"} setItem={setNumberArrived} />

                                    <FilterDateInput placeholder={"Date"} item={dateEnvoie} setItem={setDateEnvoie} />
                                </div>
                            </div>

                            <div className="add-item">
                                <span className='color-2' onClick={() => toutCocher(envois)}>Tout cocher</span>
                                <span className='color-1' onClick={getBordereauHandler}>Bordereau</span>
                                <span className='color-1' onClick={() => navigate('/envois/ajouter')}>Ajouter</span>
                                <span className='color-2' onClick={toutDecocher}>Tout décocher </span>
                            </div>

                            {
                                isFetching ? <LoadingComponent /> : (
                                    envois.length === 0 ? (
                                        <div className='no-data'>
                                            <span>Il n'y a pas encore de données</span> <br />
                                            <Link to={'/envois/ajouter'}>Ajouter un Envoie maintenant</Link>
                                        </div>
                                    )
                                        : (
                                            <>
                                                <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation='envois' />
                                                <div className="content">
                                                    {
                                                        <>
                                                            <TableComponent headers={
                                                                user.entreprise ? (
                                                                    clientOrEntreprise.id === 1 ? [groupEnvois.length === 0 ? '' : <span className='mini-th'>{groupEnvois.length}</span>, 'Tracking', 'Client', "Destinataire", "Statut", "Wilaya d'Arrivé", "Commune d'Arrivé", "Type d'Envoie", "Type Dépot", "Type Livraison", "Agence Actuelle", 'Date', 'Action']
                                                                        : [groupEnvois.length === 0 ? '' : <span className='mini-th'>{groupEnvois.length}</span>, 'Tracking', "Destinataire", "Statut", "Wilaya d'Arrivé", "Commune d'Arrivé", "Type d'Envoie", "Type Dépot", "Type Livraison", "Agence Actuelle", 'Date', 'Action']
                                                                ) : (
                                                                    //</> clientOrEntreprise.id === 1 ? ['Id', 'Client', "Statut", "Wilaya d'Arrivé", "Commune d'Arrivé", "Type d'Envoie", "Type Dépot", "Type Livraison", "Agence Actuelle", 'Date', 'Action']
                                                                    [groupEnvois.length === 0 ? '' : <span className='mini-th'>{groupEnvois.length}</span>, 'Tracking', "Destinataire", "Statut", "Wilaya d'Arrivé", "Commune d'Arrivé", "Type d'Envoie", "Type Dépot", "Type Livraison", "Agence Actuelle", 'Date', 'Action']
                                                                )
                                                            }>
                                                                {
                                                                    envois.map((envoie, index) => (
                                                                        <tr key={index} className={existElementInGroup(groupEnvois, envoie) ? 'tr-active' : ''}>
                                                                            <td><div className={existElementInGroup(groupEnvois, envoie) ? 'mini-rect-div active' : 'mini-rect-div'} onClick={() => groupEnvoisAddHandle([envoie])}></div></td>
                                                                            <td><span className={`table-special ${getTypeClass(envoie.currentStatus)}`}>{currentStatusEnvois.filter(item => item.id === envoie.currentStatus)[0]['nom']}-{envoie.tracking}</span></td>
                                                                            {clientOrEntreprise.id === 1 && (<td>{checkSize(envoie.User.username)} </td>)}
                                                                            <td style={{ textAlign: "left" }}>
                                                                                {
                                                                                    envoie.numero !== null && envoie.numero !== "" && (
                                                                                        <span style={{ fontWeight: "600" }}>{checkSize(envoie.numero)} </span>
                                                                                    )
                                                                                }
                                                                                <span>{checkSize(envoie.nomArrived)}</span>
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    envoie.dead === 1 && (envoie.type === 5 || envoie.type === 6) && (envoie.currentStatus === 1 || envoie.currentStatus === 2) ? (
                                                                                        <span className={`table-special livre`}>Livré</span>
                                                                                    ) : (
                                                                                        envoie.dead === 1 && (envoie.type === 5 || envoie.type === 6) && (envoie.currentStatus === 3 || envoie.currentStatus === 4)
                                                                                            ? <span className={`table-special retour`}>Livré</span>
                                                                                            : <span className={`table-special ${getStatusClass(envoie.type)}`}>{statusEnvois.filter(item => item.id === envoie.type)[0]['nom']}</span>
                                                                                    )
                                                                                }
                                                                            </td>
                                                                            <td>{wilayas.filter(item => item.id == envoie.wilayaArrived)[0]['nom']}</td>
                                                                            <td>
                                                                                {
                                                                                    (envoie.typeDelivery === 1 && communes[envoie.wilayaArrived].filter(item => item.id == envoie.communeArrived)[0]) ? (
                                                                                        communes[envoie.wilayaArrived].filter(item => item.id == envoie.communeArrived)[0]['nom']
                                                                                    ) : "Stop Desk"
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                <span className={`table-special-border ${getTypeEnvoie(envoie.typeEnvoie)}`}>{typeEnvois.filter(item => item.id === envoie.typeEnvoie)[0]['nom']}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className={`table-special ${getTypeDelivery(envoie.typeRamassage)}`}>{typeRamassages.filter(item => item.id === envoie.typeRamassage)[0]['nom'].slice(6)}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className={`table-special ${getTypeDelivery(envoie.typeDelivery)}`}>{typeDeliveries.filter(item => item.id === envoie.typeDelivery)[0]['nom'].slice(10)}</span>
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    (envoie.type !== 10) ? (
                                                                                        envoie.Histories[0]['Action']['agenceDepartureActionAlias']['nom']
                                                                                    ) : ("Pas Encore")
                                                                                }
                                                                            </td>
                                                                            <td>{envoie.createdAt.slice(0, 10)}</td>
                                                                            <td style={{ textAlign: "right" }}>
                                                                                {
                                                                                    envoie.Histories[0]['type'] === 10 && <span className='update' onClick={() => navigate(`/envois/update/${envoie.id}`)}>Modifier</span>
                                                                                }
                                                                                <span className='detail' onClick={() => navigate(`/envois/detail/${envoie.id}`)}>Détail</span>
                                                                                <span className='update' onClick={() => navigate(`/envois/detail/${envoie.id}/tracking`)}>Tracking</span>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </TableComponent>
                                                            {
                                                                (pages > 1) && (<PaginationComponent page={page} itemContext={EnvoieContext} item='envois' />)
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                )
                            }
                        </>
                    )
                }
            </div>

            <div className={bordActive ? 'wrapper-bord active' : 'wrapper-bord'}>
                <div className='content'>
                    <img src={`${CURRENT_URL}//nweblack.png`} />
                    <span className="loader"></span>
                </div>
            </div>
            <div style={{ opacity: "0", position: 'fixed', pointerEvents: 'none' }}>
                {
                    (groupEnvois.length !== 0) && (
                        groupEnvois.map((envoie, index) => ((
                            envoie.currentStatus === 4 ? (<div key={index}><Bordereau envoie={envoie} state={'ANL'} agences={agencesByWilaya} /></div>)
                                : (envoie.currentStatus === 3 ? (<div key={index}><Bordereau envoie={envoie} state={'RTR'} agences={agencesByWilaya} /></div>)
                                    : (
                                        ((envoie.typeEnvoie === 1) && (envoie.currentStatus === 1 || envoie.currentStatus === 2)) ? (
                                            <div key={index}>
                                                <Bordereau envoie={envoie} state={'NWE'} agences={agencesByWilaya} />
                                                <Bordereau envoie={envoie} state={'ACC'} agences={agencesByWilaya} />
                                            </div>
                                        )
                                            : (
                                                ((envoie.typeEnvoie === 2) && (envoie.currentStatus === 1)) ? (
                                                    <div key={index}>
                                                        <Bordereau envoie={envoie} state={'NWE'} agences={agencesByWilaya} />
                                                    </div>
                                                )
                                                    : (
                                                        (envoie.typeEnvoie === 3) ? (
                                                            <div key={index}>
                                                                <Bordereau envoie={envoie} state={'PKP'} agences={agencesByWilaya} />
                                                            </div>
                                                        )
                                                            : ("")
                                                    )
                                            )
                                    )
                                ))
                        ))
                    )
                }
            </div>
        </div>
    )
}

export default Envoie
